module.exports = __webpack_public_path__ + "img/VEN.a9f8ba29.svg";